import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, InputNumber, notification} from 'antd';

import {adjustProduct, getProduct, getProductStock} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";
import StockDisplay from "./StockDisplay";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AdjustProductForm extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,

    product: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    productStock: PropTypes.object,

    adjustProduct: PropTypes.func.isRequired,
    getProduct: PropTypes.func.isRequired,
    getProductStock: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.productId !== prevProps.match.params.productId) this._load();
  }

  _load() {
    const {getProduct, getProductStock, match: {params}} = this.props;
    const {productId, sku} = decodeParams(params);
    getProduct({productId});
    getProductStock({productId, sku: sku === '-' ? '' : sku});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {productId, sku} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.adjustProduct({...values, productId, sku: sku === '-' ? '' : sku});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {product, productStock, loading, form: {getFieldDecorator, getFieldsError, setFieldsValue}} = this.props;
    const expectedQuantity = (productStock && productStock.quantity) || 0;
    return (
      <Card title="Adjust Product">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Product"
          >
            {product.display}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Stock"
          >
            <StockDisplay stock={productStock}/>
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Expected Quantity"
          >
            {expectedQuantity}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Actual Quantity"
          >
            {getFieldDecorator('actualQuantity')(
              <InputNumber
                autoFocus
                onChange={actualQuantity => setFieldsValue({quantity: (actualQuantity || 0) - expectedQuantity})}
              />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Quantity Variance"
          >
            {getFieldDecorator('quantity', {
              rules: [
                {required: true, message: 'Quantity variance is required'}
              ]
            })(
              <InputNumber onChange={quantity => setFieldsValue({actualQuantity: expectedQuantity + (quantity || 0)})} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Reason"
          >
            {getFieldDecorator('reason', {
              rules: [
                {required: true, message: 'Reason is required'}
              ]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Adjust Product
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const AdjustProductPage = Form.create()(AdjustProductForm);

const mapStateToProps = state => ({
  product: state.product.product || {},
  loading: state.product.productLoading || state.product.adjustingProduct || state.product.gettingProductStock,
  productStock: state.product.productStock,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  adjustProduct,
  getProduct,
  getProductStock,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(AdjustProductPage);



// WEBPACK FOOTER //
// ./src/Product/AdjustProductPage.js